import { EnumAppMode } from '@getaccept/lib-shared/src/enums/AppMode';
import { computed } from '@vue/composition-api';
import { useSessionStore } from '../session/store/session.store';

export const useAppMode = () => {
  const sessionStore = useSessionStore();

  const appMode = computed(() => sessionStore.session.app_mode as EnumAppMode);

  const isBusiness = computed(() => appMode.value === EnumAppMode.Business);
  const isSales = computed(() => appMode.value === EnumAppMode.Sales);

  return {
    appMode,
    isBusiness,
    isSales,
  };
};
